import { render } from "./ContactPersonCreatePage.vue?vue&type=template&id=069b5c96"
import script from "./ContactPersonCreatePage.vue?vue&type=script&lang=js"
export * from "./ContactPersonCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__